<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px" @submit.native.prevent>
        <el-form-item label="模板名称">
          <el-input v-model.trim="filteForm.templateName" placeholder="请输入模板名称" clearable @keyup.enter.native="onSubmit" />
        </el-form-item>
        <el-form-item label="自理等级">
          <el-select v-model="filteForm.selfCareLevel" clearable placeholder="全部" style="width:120px">
            <el-option label="自理" :value="1" />
            <el-option label="半自理" :value="2" />
            <el-option label="不能自理" :value="3" />
            <el-option label="重度失能" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
          <el-button type="warning" plain class="el-icon-plus" @click="showAddForm">新增模板</el-button>
        </el-form-item>
      </el-form>

      <div v-loading="loading">
        <el-table :data="dataList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="模板编码" prop="templateCode" align="center" width="160" />
          <el-table-column label="模板名称" prop="templateName" align="center" />
          <el-table-column label="自理等级" align="center" width="110">
            <template slot-scope="scope">{{ selfCareLevelText(scope.row.selfCareLevel) }}</template>
          </el-table-column>
          <el-table-column label="模板类型" align="center" width="110">
            <template slot-scope="scope">{{ scope.row.templateType === 1 ? '系统预设' : '自定义' }}</template>
          </el-table-column>
          <el-table-column label="项目数" prop="projectCount" align="center" width="80" />
          <el-table-column label="状态" align="center" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
                {{ scope.row.status === 1 ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="260">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="success" size="mini" plain @click="handleCopy(scope.row)">复制</el-button>
              <el-button v-if="scope.row.templateType !== 1" type="danger" size="mini" plain @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="filteForm.pageNum"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye" />
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="860px" :close-on-click-modal="false" @close="closeDialog">
        <el-form :model="addForm" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="模板名称" required>
                <el-input v-model.trim="addForm.templateName" placeholder="请输入模板名称" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="自理等级" required>
                <el-select v-model="addForm.selfCareLevel" placeholder="请选择" style="width:100%">
                  <el-option label="自理" :value="1" />
                  <el-option label="半自理" :value="2" />
                  <el-option label="不能自理" :value="3" />
                  <el-option label="重度失能" :value="4" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="护理项目" required>
                <el-button type="primary" size="mini" plain @click="addProjectRow">添加项目</el-button>
                <el-table :data="addForm.items" border size="mini" style="margin-top:8px">
                  <el-table-column label="护理项目" min-width="140">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.projectId" placeholder="选择项目" filterable clearable
                        popper-append-to-body style="width:100%"
                        @change="val => onProjectSelect(scope.row, val)">
                        <el-option v-for="p in projectList" :key="p.id" :label="p.projectName" :value="p.id" />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="频率" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model.trim="scope.row.execFrequency" clearable placeholder="如：每天、每周2次、daily" />
                    </template>
                  </el-table-column>
                  <el-table-column label="执行时间" width="150">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.execTimes" placeholder="如08:00,14:00" />
                    </template>
                  </el-table-column>
                  <el-table-column label="时长(分)" width="120">
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.duration"
                        :min="1"
                        :max="480"
                        :precision="0"
                        :controls="false"
                        placeholder="分钟"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="70" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" size="mini" plain @click="removeProjectRow(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "NursingTemplateList",
  data() {
    return {
      filteForm: { templateName: "", selfCareLevel: null, pageNum: 1, pageSize: 20 },
      dataList: [],
      totalDataNumber: 0,
      loading: false,
      projectList: [],
      projectLoading: false,
      dialogVisible: false,
      dialogTitle: "新增护理模板",
      isEdit: false,
      addForm: { items: [], templateType: 2, status: 1 },
      submitLoading: false
    };
  },
  methods: {
    onSubmit() { this.filteForm.pageNum = 1; this.getTableData(); },
    showAddForm() {
      this.isEdit = false;
      this.dialogTitle = "新增护理模板";
      this.addForm = { items: [], templateType: 2, status: 1 };
      this.dialogVisible = true;
      this.loadProjects();
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "编辑护理模板";
      this.$postJson("omc/nursingTemplate/detail", { id: row.id }).then(res => {
        if (res.code == 200) {
          this.addForm = Object.assign({}, res.result, { items: this.normalizeItems(res.result.items) });
          this.dialogVisible = true;
          this.loadProjects();
        }
      });
    },
    parseProjectList(res) {
      if (!res || res.code != 200) return [];
      const data = res.result;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.list)) return data.list;
      return [];
    },
    handleCopy(row) {
      this.$postJson("omc/nursingTemplate/copy", { id: row.id }).then(res => {
        if (res.code == 200) {
          this.$message.success("复制成功");
          this.getTableData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除该护理模板?", "提示", { type: "warning" }).then(() => {
        this.$postJson("omc/nursingTemplate/delete", { id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.getTableData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    normalizeItems(items) {
      return (items || []).map(it => ({
        ...it,
        duration: it.duration != null && it.duration !== "" ? Number(it.duration) : 30
      }));
    },
    onProjectSelect(row, projectId) {
      const project = this.projectList.find(p => p.id === projectId);
      if (project) {
        row.projectName = project.projectName;
        const d = project.defaultDuration != null ? Number(project.defaultDuration) : 30;
        this.$set(row, "duration", d > 0 ? d : 30);
      }
    },
    addProjectRow() {
      if (!this.addForm.items) this.addForm.items = [];
      this.addForm.items.push({ execFrequency: "", duration: 30, execTimes: "" });
    },
    removeProjectRow(index) {
      this.addForm.items.splice(index, 1);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.addForm = { items: [], templateType: 2, status: 1 };
    },
    submitForm() {
      if (!this.addForm.templateName) return this.$message.warning("请输入模板名称");
      if (!this.addForm.selfCareLevel) return this.$message.warning("请选择自理等级");
      if (!this.addForm.items || !this.addForm.items.length) return this.$message.warning("请添加护理项目");
      this.submitLoading = true;
      const url = this.isEdit ? "omc/nursingTemplate/modify" : "omc/nursingTemplate/add";
      this.$postJson(url, this.addForm).then(res => {
        if (res.code == 200) {
          this.$message.success("保存成功");
          this.closeDialog();
          this.getTableData();
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => { this.submitLoading = false; });
    },
    getTableData() {
      this.loading = true;
      this.$postJson("omc/nursingTemplate/queryListWithPage", this.filteForm).then(res => {
        this.dataList = (res.result && res.result.list) ? res.result.list : [];
        this.totalDataNumber = Number(res.result && res.result.total) || 0;
      }).finally(() => { this.loading = false; });
    },
    loadProjects() {
      this.projectLoading = true;
      const loadPage = () => this.$postJson("omc/nursingProject/queryListWithPage", { pageNum: 1, pageSize: 500, status: 1 });
      this.$postJson("omc/nursingProject/listEnabled", {})
        .then(res => {
          this.projectList = this.parseProjectList(res);
          if (!this.projectList.length) return loadPage();
        })
        .then(res => {
          if (res) this.projectList = this.parseProjectList(res);
        })
        .catch(() => loadPage().then(res => { this.projectList = this.parseProjectList(res); }))
        .finally(() => { this.projectLoading = false; });
    },
    handleCurrentChange(val) {
      this.filteForm.pageNum = val;
      this.getTableData();
    },
    selfCareLevelText(v) {
      const map = { 1: "自理", 2: "半自理", 3: "不能自理", 4: "重度失能" };
      return map[v] || "";
    },
    tableRowStyle() { return "background-color: #ffffff"; },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
    }
  },
  mounted() {
    this.getTableData();
    this.loadProjects();
  },
  activated() {
    this.loadProjects();
  }
};
</script>
<style lang="scss" scoped>
.buttonlist .buttonlist-m { padding: 10px 0 0 5px; }
.fenye { margin: 0; padding: 20px 0; background: #fff; }
</style>
